import React from 'react'
import { withStyles, Grid, Typography } from '@material-ui/core'
import moment from 'moment'
import 'moment/locale/pt-br'
import ReactHtmlParser from 'react-html-parser'
import CustomScrollToBottom from '../../components/CustomScrollToBottom'

const styles = theme => ({
  usuario: {
    marginRight: theme.spacing(),
    fontWeight: 'bold'
  },
  body: {
    width: '100%'
  },
  comentario: {
    backgroundColor: theme.palette.grey['200'],
    margin: '8px 0',
    borderRadius: 16,
    padding: theme.spacing(2)
  },
  scrollDiv: {
    height: 512
  }
})

const ComentariosList = props => {
  const { classes, comentarios } = props

  const renderComentario = comentario => {
    return (
      <Grid key={comentario.id} item className={classes.body} sm={12} xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          className={classes.comentario}
        >
          <Grid item sm={10} xs={6}>
            <Typography variant="body1" className={classes.usuario}>
              {comentario.usuario}
            </Typography>
          </Grid>
          <Grid item sm={2} xs={6}>
            <Typography
              variant="body2"
              display="inline"
              gutterBottom
              align="right"
            >
              {moment(comentario.createdAt)
                .locale('pt-BR')
                .fromNow()}
            </Typography>
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography variant="body1" gutterBottom>
              {ReactHtmlParser(comentario.texto)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  const renderEmpty = () => {
    return (
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Typography variant="subtitle1">
          Nenhum comentário existente nesse chat!
        </Typography>
      </Grid>
    )
  }
  return (
    <CustomScrollToBottom className={classes.scrollDiv}>
      <Grid
        className={classes.root}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        {comentarios
          ? comentarios.map(comentario => renderComentario(comentario))
          : renderEmpty()}
      </Grid>
    </CustomScrollToBottom>
  )
}

export default withStyles(styles)(ComentariosList)
